(function () {
  'use strict';

  var SHORTCODE_PATTERN = /\[collection-carousel\s*=\s*(?:&quot;|&#34;|[“”\"]|&apos;|&#39;|[‘’'])(.*?)(?:&quot;|&#34;|[“”\"]|&apos;|&#39;|[‘’'])\]/gi;

  function normaliseHandle(value) {
    if (!value) return '';

    var cleaned = String(value)
      .replace(/&amp;/g, '&')
      .replace(/&quot;|&#34;/g, '"')
      .replace(/&apos;|&#39;/g, "'")
      .trim();

    try {
      if (/^https?:\/\//i.test(cleaned)) {
        var url = new URL(cleaned);
        cleaned = url.pathname;
      }
    } catch (error) {
      // Keep the original string if URL parsing fails.
    }

    cleaned = cleaned.split('?')[0].split('#')[0].replace(/^\/+|\/+$/g, '');

    if (cleaned.indexOf('collections/') !== -1) {
      cleaned = cleaned.split('collections/').pop();
    }

    cleaned = cleaned.split('/').filter(Boolean).pop() || cleaned;

    return cleaned
      .toLowerCase()
      .replace(/[^a-z0-9\s_-]/g, '')
      .replace(/[\s_]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function getRootUrl() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }

    return '/';
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      var currencyFormat = window.shop_currency || window.moneyFormat || '${{amount}}';
      return window.Shopify.formatMoney(cents, currencyFormat);
    }

    var amount = Number(cents || 0) / 100;
    return amount.toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'AUD' });
  }

  function productImage(product) {
    if (product.featured_image) return product.featured_image;
    if (product.images && product.images.length) return product.images[0].src || product.images[0];
    return '';
  }

  function productPrice(product) {
    var variant = product.variants && product.variants.length ? product.variants[0] : null;
    if (!variant) return '';

    var rawPrice = variant.price;
    var cents = typeof rawPrice === 'string' && rawPrice.indexOf('.') !== -1
      ? Math.round(parseFloat(rawPrice) * 100)
      : parseInt(rawPrice, 10);

    if (Number.isNaN(cents)) return '';

    return formatMoney(cents);
  }

  function renderCarousel(handle, products, title, limit) {
    var root = getRootUrl();
    var collectionUrl = root + 'collections/' + encodeURIComponent(handle);
    var visibleProducts = products.slice(0, limit || products.length);

    if (!visibleProducts.length) {
      return '<div class="cp01-collection-carousel cp01-collection-carousel--empty"><p>No products found for this collection.</p></div>';
    }

    var cards = visibleProducts.map(function (product) {
      var productUrl = collectionUrl + '/products/' + encodeURIComponent(product.handle);
      var image = productImage(product);
      var price = productPrice(product);

      return [
        '<article class="cp01-collection-carousel__item" role="listitem">',
          '<a class="cp01-collection-carousel__media" href="' + productUrl + '" aria-label="' + escapeHtml(product.title) + '">',
            image ? '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(product.title) + '" loading="lazy">' : '<span class="cp01-collection-carousel__placeholder" aria-hidden="true"></span>',
          '</a>',
          '<div class="cp01-collection-carousel__info">',
            '<h3 class="cp01-collection-carousel__product-title"><a href="' + productUrl + '">' + escapeHtml(product.title) + '</a></h3>',
            price ? '<div class="cp01-collection-carousel__price"><span class="price">' + price + '</span></div>' : '',
          '</div>',
        '</article>'
      ].join('');
    }).join('');

    return [
      '<section class="cp01-collection-carousel cp01-collection-carousel--js" aria-label="Shop ' + escapeHtml(title || handle) + '">',
        '<div class="cp01-collection-carousel__header">',
          '<h2 class="cp01-collection-carousel__title">Shop ' + escapeHtml(title || handle.replace(/-/g, ' ')) + '</h2>',
          '<a class="cp01-collection-carousel__link" href="' + collectionUrl + '">View collection</a>',
        '</div>',
        '<div class="cp01-collection-carousel__track" role="list" tabindex="0">',
          cards,
        '</div>',
      '</section>'
    ].join('');
  }

  function fetchAndRenderCarousel(container) {
    var handle = normaliseHandle(container.getAttribute('data-collection-handle'));
    var limit = parseInt(container.getAttribute('data-product-limit') || '8', 10);

    if (!handle || container.getAttribute('data-cp01-loaded') === 'true') return;

    container.setAttribute('data-cp01-loaded', 'true');
    container.innerHTML = '<div class="cp01-collection-carousel cp01-collection-carousel--loading"><p>Loading products...</p></div>';

    fetch(getRootUrl() + 'collections/' + encodeURIComponent(handle) + '/products.json?limit=' + encodeURIComponent(limit), {
      credentials: 'same-origin'
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Collection request failed');
        return response.json();
      })
      .then(function (data) {
        container.innerHTML = renderCarousel(handle, data.products || [], data.collection && data.collection.title, limit);
      })
      .catch(function () {
        container.innerHTML = '<div class="cp01-collection-carousel cp01-collection-carousel--error"><p>Products could not be loaded. <a href="' + getRootUrl() + 'collections/' + encodeURIComponent(handle) + '">View collection</a>.</p></div>';
      });
  }

  function replaceShortcodesInContent(content) {
    if (!content) return;

    var placeholders = [];
    var html = content.innerHTML;
    var replaced = html.replace(SHORTCODE_PATTERN, function (match, value) {
      var handle = normaliseHandle(value);
      if (!handle) return match;
      var id = 'cp01-carousel-' + placeholders.length + '-' + Date.now();
      placeholders.push(id);
      return '<div id="' + id + '" class="cp01-collection-carousel-host" data-collection-handle="' + escapeHtml(handle) + '" data-product-limit="' + escapeHtml(content.getAttribute('data-carousel-limit') || '8') + '"></div>';
    });

    if (replaced !== html) {
      content.innerHTML = replaced;
    }
  }

  function initCarousels(root) {
    var scope = root || document;
    var contents = scope.querySelectorAll('[data-cp01-article-content]');

    contents.forEach(function (content) {
      replaceShortcodesInContent(content);
    });

    scope.querySelectorAll('.cp01-collection-carousel-host[data-collection-handle]').forEach(fetchAndRenderCarousel);
  }

  function slugify(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&amp;/g, 'and')
      .replace(/[^a-z0-9\s-]/g, '')
      .trim()
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');
  }

  function initTableOfContents(root) {
    var scope = root || document;
    var toc = scope.querySelector('[data-cp01-toc]');
    var content = scope.querySelector('[data-cp01-article-content]');
    if (!toc || !content) return;

    var list = toc.querySelector('[data-cp01-toc-list]');
    var headings = Array.prototype.slice.call(content.querySelectorAll('h2, h3')).filter(function (heading) {
      return heading.textContent.trim().length > 0;
    });

    if (!list || headings.length < 2) {
      toc.hidden = true;
      return;
    }

    var used = {};
    list.innerHTML = headings.map(function (heading) {
      var base = slugify(heading.textContent) || 'section';
      var slug = base;
      var index = 2;

      while (used[slug] || document.getElementById(slug)) {
        slug = base + '-' + index;
        index += 1;
      }

      used[slug] = true;

      if (!heading.id) {
        heading.id = slug;
      }

      return '<li class="cp01-blog-post__toc-item cp01-blog-post__toc-item--' + heading.tagName.toLowerCase() + '"><a href="#' + escapeHtml(heading.id) + '">' + escapeHtml(heading.textContent.trim()) + '</a></li>';
    }).join('');

    toc.hidden = false;
  }

  function initResponsiveTables(root) {
    var scope = root || document;
    var content = scope.querySelector('[data-cp01-article-content]');
    if (!content) return;

    content.querySelectorAll('table').forEach(function (table) {
      if (table.parentElement && table.parentElement.classList.contains('cp01-table-scroll')) return;

      var wrapper = document.createElement('div');
      wrapper.className = 'cp01-table-scroll';
      wrapper.setAttribute('tabindex', '0');
      wrapper.setAttribute('role', 'region');
      wrapper.setAttribute('aria-label', 'Scrollable table');
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    });
  }

  function initCP01BlogPost() {
    initCarousels(document);
    initTableOfContents(document);
    initResponsiveTables(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCP01BlogPost);
  } else {
    initCP01BlogPost();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initCarousels(event.target);
    initTableOfContents(event.target);
    initResponsiveTables(event.target);
  });
})();
